import { SvgXml } from 'react-native-svg'

import { useTheme } from '../theme/restyle'

// Verbatim port of web's `CopyDoubleRoundedSquareIcon`
// (`packages/connect/src/components/Icons/CopyDoubleRoundedSquareIcon.tsx`) —
// two overlapping rounded squares. Kept as inline SVG (rendered via `SvgXml`,
// like the other connect-rn glyphs) so the package stays asset-free.
// `stroke="currentColor"` is resolved by the `color` prop below, so the glyph
// tracks the secondary-button label color.
const COPY_ADDRESS_SVG = `<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.2 5.8V4.26C10.2 3.64394 10.2 3.33591 10.0801 3.10061C9.97465 2.89363 9.80637 2.72535 9.59939 2.61989C9.36409 2.5 9.05606 2.5 8.44 2.5H4.26C3.64394 2.5 3.33591 2.5 3.10061 2.61989C2.89363 2.72535 2.72535 2.89363 2.61989 3.10061C2.5 3.33591 2.5 3.64394 2.5 4.26V8.44C2.5 9.05606 2.5 9.36409 2.61989 9.59939C2.72535 9.80637 2.89363 9.97465 3.10061 10.0801C3.33591 10.2 3.64394 10.2 4.26 10.2H5.8M7.56 13.5H11.74C12.3561 13.5 12.6641 13.5 12.8994 13.3801C13.1064 13.2746 13.2746 13.1064 13.3801 12.8994C13.5 12.6641 13.5 12.3561 13.5 11.74V7.56C13.5 6.94394 13.5 6.63591 13.3801 6.40061C13.2746 6.19363 13.1064 6.02535 12.8994 5.91989C12.6641 5.8 12.3561 5.8 11.74 5.8H7.56C6.94394 5.8 6.63591 5.8 6.40061 5.91989C6.19363 6.02535 6.02535 6.19363 5.91989 6.40061C5.8 6.63591 5.8 6.94394 5.8 7.56V11.74C5.8 12.3561 5.8 12.6641 5.91989 12.8994C6.02535 13.1064 6.19363 13.2746 6.40061 13.3801C6.63591 13.5 6.94394 13.5 7.56 13.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>`

/**
 * The "Copy address" button glyph — the RN port of web's
 * `CopyDoubleRoundedSquareIcon`. Renders in the theme's secondary-button label
 * color so it matches the button text.
 */
export function CopyAddressIcon({ size = 16 }: { size?: number }) {
  const theme = useTheme()
  return (
    <SvgXml
      xml={COPY_ADDRESS_SVG}
      width={size}
      height={size}
      color={theme.content.button.secondary.default}
    />
  )
}
